import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip component

import styled from '@emotion/styled';
import { fontFamily, fontSize } from 'theme/defaultStyle';
import ErrorDialog from 'controls/global/dialogs/error-dialog';
import DownloadIcon from 'theme/icons/DownloadIcon';
import { CancelIcon } from 'theme/icons/CancelIcon';
import { useTitleSearchActions, useTitleSearchGridItems } from 'utils/context/TitleSearchContext';

const SelectionInterfaceContainer = styled.div`
  display: flex;
  height: 35px;
  padding: 6px 8px;
  align-items: center;
  align-self: stretch;
  background: var(--Action-Blue-150, #4a66c3);
  color: #fff;
  border-radius: 4px;
  /* Set container text color to white */
`;

const SelectionText = styled.span`
  color: #fff; /* Set text color to white */
  font-family: ${fontFamily.inter};
  font-size: ${fontSize.medium};
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 20.02px */
  letter-spacing: 0.17px;
  font-feature-settings: 'clig' off, 'liga' off; /* Disable ligatures */
`;

const IconContainer = styled.div`
  display: flex;
  margin-left: auto;
`;

const CancelButton = styled.span`
  color: #fff; /* Set text color to white */
  font-family: ${fontFamily.primary};
  font-size: ${fontSize.medium};
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 20.02px */
  letter-spacing: 0.17px;
  font-feature-settings: 'clig' off, 'liga' off; /* Disable ligatures */
`;

type ImageArchiveGridProps = {
  disabled: boolean,
  onDownload?: () => void,
  orderID?: number,
};

export const MultipleDownloadHeader: React.FC<ImageArchiveGridProps> = ({ disabled=false, onDownload, orderID }) => {
  const [errorMessage, setErrorMessage] = useState<string | React.ReactNode>('');
  const [openErrorDialog, setOpenErrorDialog] = useState<boolean>(false);
  const [,{resetSelectedTitleSearchGridItems}] = useTitleSearchActions();
  const [{selectedTitleSearchGridItems}] = useTitleSearchGridItems();


  // const { permissionCodes } = useSelector<RootStateType, PermissionStore>(
  //   (state) => state.permission
  // );

  // const reuploadPermission = permissionCodes.includes(PERMISSIONS.UPLOADS_POLICYIMAGES_REUPLOAD);

  const resetSelection = () => {
    resetSelectedTitleSearchGridItems(orderID);
  };

  const handleOnDownload = () => {
    onDownload && onDownload();
  };

  const handleOnYesErrorDialog = () => {
    setOpenErrorDialog(false);
    setErrorMessage('');
    // setCorrelationId('');
  };

  return (
    <>
      <SelectionInterfaceContainer>
        <SelectionText>
          {selectedTitleSearchGridItems?.filter((d)=>d.orderID === orderID)?.length} item(s) selected
        </SelectionText>
        <IconContainer>
          <Tooltip title="Download">
            <IconButton aria-label="download" disabled={disabled} onClick={handleOnDownload}>
              <DownloadIcon color="white" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancel">
            <IconButton aria-label="cancel" style={{ color: '#FFF' }} disabled={disabled} onClick={resetSelection}>
              <CancelIcon />
              <CancelButton>Cancel</CancelButton>
            </IconButton>
          </Tooltip>
        </IconContainer>
      </SelectionInterfaceContainer>
      <ErrorDialog
        isOpen={openErrorDialog}
        confirmationMessage={errorMessage}
        // correlationId={correlationId}
        onYes={handleOnYesErrorDialog}
      />
    </>
  );
  
};
